import { LockPercentIcon } from './LockPercentIcon';

/**
 * author: mocking-mike
 * id 2FFF3573-6379-4712-AC2D-0FDDFECE2103
 * name lock-percent
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-percent.svg
 * tags
 */
export const LockRateIcon = LockPercentIcon;
export default LockRateIcon